<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <button type="button" id="btnLoadList" (click)="MainGridTable()" style="display:none">Get</button>
        <button type="button" id="BtnPopup" (click)="GetBatchNoList()" style="display:none">Search</button>
        <button type="button" id="btnDeleteDT" (click)="DeleteArticleType()" style="display:none">Delete</button>
        <button type="button" id="btnDeleteConfirm" (click)="DeleteConfirm()" style="display:none">Delete Confirm</button>
        <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
        <button type="button" id="btnAllocate" (click)="ArticleList()" style="display:none">Columns</button>
        <button type="button" id="btnUploadConfirm" (click)="FinalDeliveryConfirm()" style="display:none">Columns</button>

        <button type="button" id="btnStartConfirm" (click)="StartProcessConfirm()" style="display:none">Columns</button>
        <div class="divContainer" style="top:-10px;">

          <ul class="nav nav-tabs nav-tabs-custom" id="TabulArticleList">
            <li class="nav-item"><a data-toggle="tab" href="#WIPList" name="WIP" class="nav-link active" (click)="GetDataByActiveTab('WIP')">WIP</a></li>
            <li class="nav-item"><a data-toggle="tab" href="#PublishedList" name="Published" class="nav-link" (click)="GetDataByActiveTab('Published')">Published</a></li>
          </ul>
          <br />
          <div class="col-sm-12" id="divMainFilter">
            <div class="row">
              <div class="col-sm-6">
                <label>Batch</label>
                <select class="form-control" id="ddlSearchBatch" multiple>
                  <option value="0" disabled selected>Select Batch</option>
                  <option *ngFor="let itemCT of BatchList" value={{itemCT.Batch}}>{{itemCT.Batch}}</option>
                </select>
              </div>
              <div class="col-sm-4">
                <button type="button" class="btn btn-outline-info waves-effect waves-light clsMargin" title="Get" (click)="getFiltered()">Search</button>
                <button type="button" class="btn btn-outline-danger waves-effect waves-light clsMargin" title="Clear" (click)="resetFilter()" style="margin-left:10px">Reset</button>
              </div>
            </div>
          </div>
        </div>
        <br />

        <!--table-->
        <table #dataTable class="display" style="width:100%"></table>

        <!--Action popup Page-->
        <div id="btnPopupartDetails" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-lg">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title"> {{title}} </h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()"></button>
              </div>
              <!--popupbody-->
              <div class="modal-body" id="popupbody">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <label for="ddlBatch" class="control-label">Batch<em>*</em></label>
                      <select class="form-control" id="ddlBatch">
                        <option value="0" disabled selected>Select Batch</option>
                        <option *ngFor="let itemCT of BatchList" value={{itemCT.Batch}}>{{itemCT.Batch}}</option>
                      </select>
                    </div>
                  </div>
                </div>

              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="{{popUpButtonText}}" id="btnWF" (click)="AddBatchSet()"> {{popUpButtonText}} </button>
              </div>
              <div id="LoadingImagePopup">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>
            </div>
          </div>
        </div>

        <div id="btnPopupHRW" class="modal" style="position: fixed !important;display:none">
          <div class="modal-dialog modal-xl">
            <div class="modal-content" id="modal_contentArt">
              <div class="modal-header" style="text-align:center">
                <h4 class="modal-title" id="hrwArticleList">Article List</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()"></button>
              </div>
              <!--popupbody-->
              <div class="modal-body" id="popupHRWbody">
                <div class="form-group">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group tblArticleList fixTableHead">
                        <table id="tblArticleList" class="table" style="width: 100%;white-space:nowrap;">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Article</th>
                              <th>Received Date</th>
                              <th>HW Start</th>
                              <th>HW Completed</th>
                              <th>Duration (min)</th>
                              <th>S3 Start</th>
                              <th>S3 Completed</th>
                              <th>Duration (min)</th>
                            </tr>
                          </thead>
                          <tbody>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <!--popup body end-->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hideFinal()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Final Delivery" id="btnFinalDelivery" (click)="FinalDelivery()">Final Delivery</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" title="Start Process" id="btnStartProcess" (click)="StartProcess()">Start</button>
              </div>
              <div id="LoadingImagePopup2">
                <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loding..." />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
